module.exports = __webpack_public_path__ + "images/forza-horizon-4_rgba(0,0,0,0.7).jpg?v=ce83f56da83fac2446275b3049d1610e";